"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var LocationPin = function LocationPin(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 10 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 13 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#fff" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 10 13",
    scale: height / 13,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.367 12.746c.119.17.288.254.508.254.22 0 .39-.085.508-.254l1.701-2.437A98.224 98.224 0 0 0 8.76 7.846c.39-.61.651-1.122.787-1.536.135-.415.203-.893.203-1.435 0-.88-.22-1.693-.66-2.438A4.968 4.968 0 0 0 7.313.66 4.705 4.705 0 0 0 4.874 0c-.88 0-1.693.22-2.438.66A4.968 4.968 0 0 0 .66 2.437 4.705 4.705 0 0 0 0 4.876c0 .542.068 1.02.203 1.435.12.368.341.814.662 1.336l.233.366c.279.425.753 1.12 1.422 2.086l1.317 1.88c.193.278.37.534.53.768zm.508-5.84A1.956 1.956 0 0 1 3.44 6.31a1.956 1.956 0 0 1-.596-1.435c0-.559.199-1.037.596-1.435a1.956 1.956 0 0 1 1.435-.596c.559 0 1.037.199 1.435.596.397.398.596.876.596 1.435S6.707 5.912 6.31 6.31a1.956 1.956 0 0 1-1.435.596z",
    id: "locationPin"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#locationPin"
  }));
};

var _default = LocationPin;
exports["default"] = _default;
module.exports = exports["default"];